<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
    <div class="loader2"></div>
</div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li *ngIf="loginPersonType=='EMPLOYEE'"><a>Manage</a></li>
          <li *ngIf="loginPersonType=='EMPLOYEE'"><a>Business</a></li>
          <li *ngIf="loginPersonType=='EMPLOYEE'"><a>Business Entities</a></li>
          <li *ngIf="loginPersonType=='EMPLOYEE'"><a>Provider Farm Businesses</a></li>
          <li *ngIf="loginPersonType=='EMPLOYEE'"><a>Provider Farm Business Locations</a></li>
          <li *ngIf="loginPersonType != 'EMPLOYEE'"><a>Your Customers</a></li>
          <li *ngIf="loginPersonType != 'EMPLOYEE'"><a>Locations</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
           <a routerLink="/home/BusinessEntityFarmsProvider/{{paramsbusinessId}}/{{paramBusiness}}"><img src="../../../../../../../assets/images/New_Icons/back-transprent-icon.svg" title="Back"></a>
          <a routerLink="/home"><img src="../../../../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="block">
        <div class="row business_info_container">
          <div class="business_info_details">
            <div class="business_name_div">
              <span>{{businessEntity && businessEntity.businessName}}</span><br>
            </div>
            <div class="business_info">
              <div class="business_address_div">
                <span>
                  {{((businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode}}
                  ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].street}}
                  ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].city}}
                </span>
              </div>
              <div class="business_email_div">
                <img src="../../../../../../../assets/images/New_Icons/email-icon.svg">
                <span>{{businessEntity && businessEntity.email == '' || businessEntity && businessEntity.email == null ? 'NA' : businessEntity && businessEntity.email}}</span>
              </div>
              <div class="business_mobile_number_div">
                <img src="../../../../../../../assets/images/New_Icons/mobile-icon.svg">
                <span>{{businessEntity && businessEntity.dialingCode}} {{businessEntity && businessEntity.mobileNumber }}</span>
              </div>
              <div class="business_type_div">
                <img src="../../../../../../../assets/images/New_Icons/company-name-icon.svg">
                <span>{{businessEntity && businessEntity.businessType[0] && businessEntity.businessType[0].name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" [hidden]="!pgLoad" [ngClass]="(loginPersonType == 'Farm Manager') ?'managerStyle':''">
          <div class="search_cum_icons_button_container">
            <div class="gap"></div>
            <div class="add-button-container" (click)="goToBusinessEntityFarms('', 'add')">
              <button class="button">
                <span class="icon"><img src="../../../../../../../assets/images/New_Icons/plus-icon.svg"></span>
                <span class="text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <!--<div class="row farm_block">
          <div class="col-lg-12 farmProvider_details">
            <div class="col-xs-12 col-sm-12 col-md-3">
              <h3>{{businessEntity && businessEntity.businessName}}</h3>
              <p>{{businessEntity && businessEntity.businessType[0] && businessEntity.businessType[0].name}}</p>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3">
              <p><i class="fa fa-envelope"
                    aria-hidden="true"></i>
                {{((businessEntity && businessEntity.email) == '' || (businessEntity && businessEntity.email == null)) ? 'NA' : businessEntity && businessEntity.email}}
              </p>
              <p><i class="fa fa-phone"
                    aria-hidden="true"></i> {{(businessEntity && businessEntity.mobileNumber == '') || (businessEntity && businessEntity.mobileNumber == null) ? 'NA' : businessEntity && businessEntity.mobileNumber }}
              </p>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3">
              <p>{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode}}
                ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].street}}
                ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].city}}
              </p>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3">
              &lt;!&ndash;<p class="handSymbol"
                 routerLink="/FarmProviderUpdate/{{businessEntity && businessEntity.id}}/gotofarmsitefpfarm/{{paramsbusinessId}}">
                <i class="fa fa-pencil" aria-hidden="true"></i></p>&ndash;&gt;
            </div>
          </div>
        </div>
        <div class="row" [hidden]="!pgLoad" *ngIf="appPermission[0].siteButton">
          <button class="addBtn" (click)="goToBusinessEntityFarms()">Add New</button>
        </div>-->
        <div class="cards_container">
          <div class="card_wrapper" *ngFor="let eachaactivedocdata of farmSites">
            <div class="each_card_div">
              <div class="card_content">
                <div class="card_header">
                  <div class="img_cum_business_name_div">
                    <img src="../../../../../../../assets/images/New_Icons/card-heading.svg">
                    <span (click)="goToBusinessEntityFarmSite(eachaactivedocdata)">{{eachaactivedocdata && eachaactivedocdata.farmNameAtLocation}}</span>
                  </div>
                </div>
                <div class="card_body">
                  <div>
                    <span>Area:</span>
                    <span
                      class="description">{{eachaactivedocdata.totalFarmArea && eachaactivedocdata.totalFarmArea != null ? eachaactivedocdata.totalFarmArea: 'NA'}}</span>
                  </div>
                  <div>
                    <span>Water Type:</span>
                    <span
                      class="description">{{eachaactivedocdata.waterType && eachaactivedocdata.waterType.name != null ? eachaactivedocdata.waterType.name : 'NA'}}</span>
                  </div>
                  <div>
                    <span>Soil Type:</span>
                    <span
                      class="description">{{eachaactivedocdata.soilType && eachaactivedocdata.soilType.name != null ? eachaactivedocdata.soilType.name: 'NA'}}</span>
                  </div>
                </div>
              </div>
              <div class="card_footer">
                <div class="separate_field">
                  <span class="field_text">Ownership: </span>
                  <span
                    class="field_value_text">{{((eachaactivedocdata && eachaactivedocdata.ownership) == '' || (eachaactivedocdata && eachaactivedocdata.ownership) == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.ownership}}</span>
                </div>
                <div class="activities_icons" *ngIf="loginPersonType != 'EMPLOYEE' && loginPersonType != 'Provider Manager'">
                  <a>
                    <img src="../../../../../../../assets/images/New_Icons/edit.svg" title="Edit Farmsite" (click)="goToBusinessEntityFarms(eachaactivedocdata.id, 'edit')" class="activities_images">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 col-xs-12" *ngIf=" farmSites && farmSites.length == 0"
             style="margin-top: 20px;">
          <h1>No Data</h1>
        </div>
        <!--<div class="row row-flex">
          <div class="col-md-3 col-sm-12 col-xs-12" *ngIf=" farmSites && farmSites.length == 0"
               style="margin-top: 20px;">
            <h1>No Data</h1>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-4" *ngFor="let eachaactivedocdata of farmSites">
            <div class="businessblockHeading ">
              <div class="row businesstype_data">
                <div class="col-xs-12 handSymbol" style="padding: 0px;">
                    <p class="farm_name" (click)="goToBusinessEntityFarmSite(eachaactivedocdata)">
                      {{eachaactivedocdata && eachaactivedocdata.farmNameAtLocation == "" ? 'NA' : eachaactivedocdata && eachaactivedocdata.farmNameAtLocation}}</p>
                </div>
                <div class="col-xs-12">
                  <p>{{((eachaactivedocdata && eachaactivedocdata.ownership) == '' || (eachaactivedocdata && eachaactivedocdata.ownership) == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.ownership}}</p>
                </div>
              </div>
              <div class="row">
                <div class="contactDetails">
                  <p>
                    Area: {{eachaactivedocdata.totalFarmArea && eachaactivedocdata.totalFarmArea != null ? eachaactivedocdata.totalFarmArea: 'NA'}}
                  </p>
                  <p>Water Type: {{eachaactivedocdata.waterType && eachaactivedocdata.waterType.name != null ? eachaactivedocdata.waterType.name : 'NA'}}
                  </p>
                  <p>Soil Type: {{eachaactivedocdata.soilType && eachaactivedocdata.soilType.name != null ? eachaactivedocdata.soilType.name: 'NA'}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</div>
